import { differenceInCalendarDays } from "date-fns";

import { CUSTOMER_ACTIVE_REWARDS_TYPES } from "./constants";
import type { CustomerActiveRewardsEntity } from "./models/RewardsCustomerRewardsEntities";
import type { CustomerActiveRewardInfo } from "./types";

export const getCustomerActiveRewardsInfo = (
    item: CustomerActiveRewardsEntity
): CustomerActiveRewardInfo => {
    const { type } = item;

    if (type === CUSTOMER_ACTIVE_REWARDS_TYPES.reward) {
        return {
            label: item.earningRule.title,
            icon: item.earningRule.icon,
            value: item.id,
        };
    }

    if (type === CUSTOMER_ACTIVE_REWARDS_TYPES.tier) {
        return { label: item.tier.title, icon: item.tier.icon, value: item.id };
    }

    if (type === CUSTOMER_ACTIVE_REWARDS_TYPES.redeem) {
        return {
            label: item.spendingRule.title,
            icon: item.spendingRule.icon,
            value: item.id,
            pointsPrice: item.spendingRule.pointsPrice,
        };
    }

    if (type === CUSTOMER_ACTIVE_REWARDS_TYPES.referrer) {
        return {
            label: item.referrer.title,
            icon: item.referrer.icon,
            value: item.id,
        };
    }

    if (type === CUSTOMER_ACTIVE_REWARDS_TYPES.referred) {
        return {
            label: item.referred.title,
            icon: item.referred.icon,
            value: item.id,
        };
    }

    return { label: "", icon: null, value: 0 };
};

export const getDiscountCodeDaysLeft = (
    endsAt: string | null
): number | null => {
    if (!endsAt) return null;
    return differenceInCalendarDays(new Date(endsAt), new Date());
};
